import { Tile } from "@carbon/react";

export interface StatsCardProps {
  title: string;
  stats: Array<{ label: string; value: number }>;
}

/**
 * The Overview tab's stats sidebar (address/contact/certification/file counts). Split out of the
 * pre-Carbon `CompanyProfile.tsx` (Task 6) — now a Carbon `Tile` in place of the Tailwind
 * `bg-white rounded-xl shadow-lg` card.
 */
const StatsCard = ({ title, stats }: StatsCardProps) => (
  <Tile className="company-profile__stats-card">
    <h3>{title}</h3>
    <dl className="company-profile__stats-list">
      {stats.map((stat) => (
        <div key={stat.label} className="company-profile__stats-row">
          <dt>{stat.label}</dt>
          <dd>{stat.value}</dd>
        </div>
      ))}
    </dl>
  </Tile>
);

export default StatsCard;
